import React, { createContext, useContext, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { clearUserData, LANGUAGE_ENUM, api } from '@/shared'
import { authThunks } from '@/app/store/auth'
import { dictThunks } from '@app/store/dict'
import Cookies from 'js-cookie'
import { useNavigate } from 'react-router-dom'
import { getCurrentLanguage } from '@/i18next'
import { nominationThunks } from '@/entity/nomination'
import { userSelectors } from '@/entity'

const AuthContext = createContext(null)

export const AuthorisePassport = ({ children }) => {
	return <AuthProvider>{children}</AuthProvider>
}

export const useAuth = () => {
	return useContext(AuthContext)
}

export const AuthProvider = ({ children }) => {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const lang = getCurrentLanguage()
	const user = useSelector(userSelectors.user)

	const isLogged =  user

	const initialState = {
		loading: false,
		success: false,
		failed: false,
		data: false,
	}

	const [authData, setAuthData] = useState({ ...initialState, data: isLogged })

	const onErrorHandler = () => {
		setAuthData({
			...initialState,
			failed: true,
		})
		Cookies.remove('hr_logged')
		Cookies.remove('UserInfo')
		clearUserData()
	}

	const handleGetCurrentUser = ({
																	params = {},
																	onSuccess = (user) => {
																	},
																	onError = () => {
																	},
																} = {}) => {
		setAuthData(prev => ({
			...initialState,
			data: prev.data,
			loading: true,
		}))

		if (!authData.loading) {
			dispatch(
				authThunks.getCurrentUser(
					{
						data: {},
						navigate,
					},
					params,
					(user) => {
						dispatch(dictThunks.getDictionaryVersion())
						if (!sessionStorage.getItem('mio_check_done')) {
							dispatch(nominationThunks.getMioCheckUser())
							sessionStorage.setItem('mio_check_done', '1')
						}
						setAuthData({
							...initialState,
							data: true,
							success: true,
						})
						onSuccess(user)
					},
					() => {
						onErrorHandler()
						onError()
					}
				)
			)
		}
	}

	const handleAuth = () => {
		const href = {
			[LANGUAGE_ENUM.kz]: process.env.REACT_APP_LOGIN + 'kk' + process.env.REACT_APP_REDIRECT_ROLE,
			[LANGUAGE_ENUM.rus]: process.env.REACT_APP_LOGIN + 'ru' + process.env.REACT_APP_REDIRECT_ROLE,
		}

		window.location.href = href[lang] || process.env.REACT_APP_LOGIN_URL
	}

	const handleLogout = async () => {
		await api.auth
			.logout()
			.then(() => {
				clearUserData()
				window.location.href = process.env.REACT_APP_LOGOUT_REDIRECT
			})
			.catch((e) => null)
	}

	const value = {
		authData,
		handleAuth,
		handleLogout,
		handleGetCurrentUser,
	}

	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
